import {
  getCoreRowModel,
  getSortedRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  useReactTable,
  SortingState,
} from "@tanstack/react-table"
import { useEffect, useState } from "react"

import { Table } from "~/components/table/Table.tsx"
import { FindCertificatesByOrganizationIdResponseDto } from "~/gen/api"
import { CERTIFICATE_CATEGORIES_VIEW_COLUMNS } from "~/pages/Brand/Certificates/constants"
import { useColumns } from "~/pages/Brand/Certificates/hooks/columns"
import { useCertificatesTableContext } from "~/pages/Brand/Certificates/provider/CertificatesTableContext"

const PAGE_SIZE = 50

export const CertificatesList = () => {
  const {
    certificates,
    view,
    globalFilter,
    checkedCertificates,
    setSelectedCertificateInfo,
    setCheckedCertificates,
    setGlobalFilter,
  } = useCertificatesTableContext()

  const [sorting, setSorting] = useState<SortingState>([
    {
      id: "status",
      desc: false,
    },
  ])

  const [columnVisibility, setColumnVisibility] = useState<
    Record<string, boolean>
  >(CERTIFICATE_CATEGORIES_VIEW_COLUMNS[view])

  useEffect(() => {
    setColumnVisibility(CERTIFICATE_CATEGORIES_VIEW_COLUMNS[view])
  }, [view])

  const columns = useColumns()

  const table = useReactTable({
    data: certificates,
    columns,
    initialState: {
      pagination: {
        pageSize: PAGE_SIZE,
      },
    },
    state: {
      sorting,
      globalFilter,
      columnVisibility,
      columnPinning: { left: ["type_name"] },
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnVisibilityChange: setColumnVisibility,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })

  return (
    <Table<FindCertificatesByOrganizationIdResponseDto>
      table={table}
      onRowClick={(row: FindCertificatesByOrganizationIdResponseDto) => {
        setSelectedCertificateInfo(row)
      }}
      checkboxSelection={{
        selectedRows: checkedCertificates,
        setSelectedRows: setCheckedCertificates,
        getRowId: (row) => row.id,
      }}
    />
  )
}
